import { render, staticRenderFns } from "./compliance.vue?vue&type=template&id=dbb9316c&scoped=true&"
import script from "./compliance.vue?vue&type=script&lang=js&"
export * from "./compliance.vue?vue&type=script&lang=js&"
import style0 from "./compliance.vue?vue&type=style&index=0&id=dbb9316c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb9316c",
  null
  
)

export default component.exports